/* NECCST cookie consent. Ports the design comp and wires Accept / Decline / Save to
   Shopify's Customer Privacy (consent tracking) API, so the choice actually gates Shopify
   and app cookies (analytics / marketing / preferences). Falls back to a localStorage flag
   when the API is unavailable so the banner still works and remembers the choice.

   The banner is hidden by default and shown only when consent has not been collected yet
   (no flash for returning visitors). The footer "Cookie settings" entry re-opens the
   preferences: bind any [data-cc-open] element or any link whose href ends in
   "#cookie-settings" (add such a link to the footer Legal menu in admin). */
(function () {
  var root = document.getElementById('ccRoot');
  if (!root) return;
  var banner = document.getElementById('ccBanner');
  var scrim = document.getElementById('ccScrim');
  var checks = [].slice.call(scrim.querySelectorAll('.cc-check[data-key]'));
  var STORAGE = 'neccst_cc_v1';

  function saved() { try { return JSON.parse(localStorage.getItem(STORAGE)); } catch (e) { return null; } }
  function prefill() {
    var s = saved();
    if (!s) return;
    checks.forEach(function (c) {
      var k = c.getAttribute('data-key');
      if (k in s) c.setAttribute('aria-checked', s[k] ? 'true' : 'false');
    });
  }
  function setAll(v) { checks.forEach(function (c) { c.setAttribute('aria-checked', v ? 'true' : 'false'); }); }
  function readChecks() {
    var o = {};
    checks.forEach(function (c) { o[c.getAttribute('data-key')] = c.getAttribute('aria-checked') === 'true'; });
    return o;
  }

  function openDialog() { prefill(); scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('is-open'); }); }
  function closeDialog() { scrim.classList.remove('is-open'); setTimeout(function () { scrim.hidden = true; }, 220); }
  function showBanner() { banner.hidden = false; }
  function hideBanner() { banner.hidden = true; }
  function dismiss() { closeDialog(); hideBanner(); }

  // Push the choice to Shopify's consent API (and remember it locally).
  function apply(prefs) {
    try { localStorage.setItem(STORAGE, JSON.stringify(prefs)); } catch (e) {}
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.setTrackingConsent === 'function') {
      cp.setTrackingConsent({
        analytics: !!prefs.analytics,
        marketing: !!prefs.marketing,
        preferences: !!prefs.personalization,
        sale_of_data: !!prefs.marketing
      }, function () {});
    }
  }

  checks.forEach(function (c) {
    c.addEventListener('click', function () {
      c.setAttribute('aria-checked', c.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
    });
  });

  var manage = document.getElementById('ccManage');
  if (manage) manage.addEventListener('click', openDialog);
  var close = document.getElementById('ccClose');
  if (close) close.addEventListener('click', closeDialog);
  scrim.addEventListener('click', function (e) { if (e.target === scrim) closeDialog(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !scrim.hidden) closeDialog(); });

  // Footer "Cookie settings" (or any [data-cc-open]) re-opens the preferences panel.
  // Also handles Shopify's standard reshow anchor "#shopifyReshowConsentBanner" (used by the
  // managed cookie/privacy links and the /policies page) since our custom banner replaces the
  // native one that hash would otherwise drive.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-cc-open], a[href$="#cookie-settings"], a[href$="#shopifyReshowConsentBanner"]');
    if (t) { e.preventDefault(); openDialog(); }
  });

  // Cross-page case: a link on another page points at "/policies#shopifyReshowConsentBanner",
  // so this page loads with the hash already set. Open the preferences on load (and on
  // hashchange, in case the SPA-less navigation only swaps the fragment).
  function maybeOpenFromHash() {
    if (location.hash === '#shopifyReshowConsentBanner' || location.hash === '#cookie-settings') openDialog();
  }
  window.addEventListener('hashchange', maybeOpenFromHash);

  [].slice.call(root.querySelectorAll('[data-cc]')).forEach(function (b) {
    b.addEventListener('click', function () {
      var a = b.getAttribute('data-cc');
      if (a === 'accept') { setAll(true); apply({ analytics: true, marketing: true, personalization: true }); }
      else if (a === 'decline') { setAll(false); apply({ analytics: false, marketing: false, personalization: false }); }
      else if (a === 'save') { apply(readChecks()); }
      dismiss();
    });
  });

  // Expose for console / preview: NECCST_CC.banner() and NECCST_CC.prefs().
  window.NECCST_CC = { banner: showBanner, prefs: openDialog, reset: function () { try { localStorage.removeItem(STORAGE); } catch (e) {} showBanner(); } };

  // Preview override: ?cc=1 (or #cookie-preview) force-shows the banner regardless of the
  // consent API, so it can be reviewed on the dev theme even when Shopify says it isn't needed.
  if (/[?&]cc=(1|show|force)/.test(location.search) || location.hash === '#cookie-preview') {
    showBanner();
    return;
  }

  // Decide whether to surface the banner. The local choice is authoritative: once the
  // visitor has chosen, never reshow it (re-apply that choice to Shopify each load so
  // cookies stay gated even if setTrackingConsent didn't land on the original click).
  function decide() {
    var s = saved();
    if (s) {
      apply({ analytics: !!s.analytics, marketing: !!s.marketing, personalization: !!s.personalization });
      hideBanner();
      return;
    }
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.shouldShowBanner === 'function') {
      try { if (cp.shouldShowBanner()) showBanner(); } catch (e) { showBanner(); }
    } else {
      showBanner();
    }
  }
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { decide(); });
  } else {
    decide();
  }

  // If we arrived via a reshow anchor (e.g. /policies#shopifyReshowConsentBanner), open the
  // preferences panel now that everything is wired.
  maybeOpenFromHash();
})();
